export const CARD_SHADOW = {
    NONE: 'none',
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
};

export const CARD_SHADOWS = Object.values(CARD_SHADOW);
